import { StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { DOBRA, DOBRA_BOLD } from '../../../theme/fonts'
import { CloseIcon } from './CloseIcon'

interface Props {
  onDelete: () => void
  cardTitle: string
  info: {
    jobName: string
    choreName: string
  }
}

export const ChoreCard = ({ onDelete, cardTitle, info }: Props) => {
  return (
    <View style={styles.card}>
      <View style={styles.header}>
        <Text style={styles.title}>{cardTitle}</Text>
        <TouchableOpacity onPress={onDelete} activeOpacity={0.7}>
          <CloseIcon />
        </TouchableOpacity>
      </View>

      <View style={styles.row}>
        <Text style={styles.title}>Trabajo:</Text>
        <Text style={styles.label}>{info.jobName}</Text>
      </View>

      <View style={styles.row}>
        <Text style={styles.title}>Faena:</Text>
        <Text style={styles.label}>{info.choreName}</Text>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  card: {
    gap: 2,
    borderColor: '#00B998',
    borderWidth: 1,
    borderRadius: 8,
    padding: 8,
    paddingHorizontal: 12,
    backgroundColor: '#F5FFFD',
  },
  header: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 8 },
  title: {
    fontFamily: DOBRA_BOLD,
    fontSize: 16,
    fontWeight: '300',
    lineHeight: 22,
    textAlign: 'center',
    color: '#00B998',
    flexWrap: 'wrap',
  },

  row: { flexDirection: 'row', gap: 8, flexWrap: 'wrap' },
  label: {
    fontFamily: DOBRA,
    fontSize: 16,
    fontWeight: '100',
    lineHeight: 22,
    color: '#00B998',
  },
})
